import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import FeaturedProperties from '../FeaturedProperties';
import { SeoBlurb } from '../SearchContext';
import { getFeaturedItems } from '../helpers';
import { PropertyOrPromoItem } from '../helpers/featuredProperties';

type Props = {
    readonly properties: PropertyOrPromoItem[];
    sectionType: SeoBlurb['transactionType'];
    propertyType?: string;
    // the area identifier of current results, e.g. "london" or "london/copper-row/se1-2lh"
    identifier?: string;
    searchParam?: string;
};

const StyledFeaturedListings = styled(FeaturedProperties)(
    ({ theme }) => css`
        ${theme.mediaQueries.medium} {
            margin-bottom: ${theme.spacing['24px']};
        }

        ${theme.mediaQueries.extraLarge} {
            margin-bottom: ${theme.spacing['32px']};
        }
    `
);

const FeaturedPropertyList: React.FC<Props> = ({
    properties,
    sectionType,
    identifier,
    searchParam,
    propertyType
}) => {
    return (
        <StyledFeaturedListings
            featuredItems={getFeaturedItems(properties)}
            sectionType={sectionType}
            searchParam={
                identifier
                    ? `${propertyType}/${identifier}/?identifier=${identifier}${
                          searchParam ? `&${searchParam}` : ''
                      }`
                    : ''
            }
        />
    );
};

export default FeaturedPropertyList;
